export interface FrameCoalescer {
  schedule: () => void;
  cancel: () => void;
}

export function createFrameCoalescer(flush: () => void): FrameCoalescer {
  let frame: number | null = null;
  return {
    schedule: () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        flush();
      });
    },
    cancel: () => {
      if (frame === null) return;
      cancelAnimationFrame(frame);
      frame = null;
    },
  };
}
